import React from "react";
import {
  Box,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom"; // Import Link
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import DashboardIcon from "@mui/icons-material/Dashboard";
import HelpIcon from "@mui/icons-material/Help";
import NewspaperIcon from "@mui/icons-material/Newspaper";

const SideBar = () => {
  const menuItems = [
    { text: "Dashboard", icon: <HomeIcon />, link: "/admin" },
    { text: "Notícias", icon: <NewspaperIcon />, link: "/admin/news" },
    { text: "Publicações", icon: <DashboardIcon />, link: "/admin/publications" },
    { text: "Usuários", icon: <PeopleIcon />, link: "/admin/users" },
    { text: "Suporte", icon: <HelpIcon />, link: "https://prosipe.com/suporte/" },
  ];

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: 240,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: 240,
            boxSizing: "border-box",
            backgroundColor: "#2c3e50",
            color: "#fff",
          },
        }}
      >
        <Typography variant="h6" textAlign="center" mt={2}>
          Painel Administrativo
        </Typography>
        <List>
          {menuItems.map((item, index) => (
            <Link
              to={item.link}
              key={index}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <ListItem button>
                <ListItemIcon sx={{ color: "#fff" }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            </Link>
          ))}
        </List>
      </Drawer>
    </Box>
  );
};

export default SideBar;
